import { ArrowUp } from "@phosphor-icons/react";
import { profile } from "../data/profile";
import { useScrollTo } from "../lib/smoothScroll";
import s from "./Footer.module.css";

export default function Footer() {
  const scrollTo = useScrollTo();
  return (
    <footer className={s.footer}>
      <div className={`container ${s.inner}`}>
        <p>
          © {new Date().getFullYear()} {profile.name}
        </p>
        <a
          href="#top"
          className={s.top}
          onClick={(e) => {
            e.preventDefault();
            scrollTo("#top");
          }}
        >
          Back to top
          <ArrowUp size={15} weight="bold" aria-hidden="true" />
        </a>
      </div>
    </footer>
  );
}
